import { ClaimRewardSchema } from '@bonanza-social/toolkit/services';
import { z } from '@bonanza-social/toolkit/api';

export const StatusSchema = z.enum([
  'Member',
  'Amethyst',
  'Topaz',
  'Aquamarine',
  'Opal',
  'Emerald',
  'Ruby',
  'Sapphire',
  'Diamond',
  'Vip',
]);

export const PlayerStatusStateSchema = z.enum([
  'ToBePromoted',
  'ToBeDemoted',
  'ToBeKept',
  'Expired',
  'Active',
  'Completed',
]);

export const StatusRewardSchema = z.object({
  rewardId: z.number(),
  rewardType: z.string(),
  expiryDate: z.string().optional(),
  sourceType: StatusSchema,
});
export const RewardStrategySchema = z.enum(['Auto', 'ClaimBased']);

export const StatusResponseSchema = z.object({
  playerStatus: StatusSchema,
  playerStatusState: PlayerStatusStateSchema,
  expiryDate: z.string().datetime().optional(),
  accumulatedLoyaltyPoints: z.number(),
  totalLoyaltyPoints: z.number(),
  pendingRewards: z.array(StatusRewardSchema).default([]),
  claimedBoxesCount: z.number().optional(),
  keepStatusNumberOfBoxes: z.number().optional(),
  promotionNumberOfBoxes: z.number().optional(),
  nextPlayerStatus: StatusSchema.optional(),
  nextStatusRewardAmount: z.number().optional(),
  rewardStrategy: RewardStrategySchema,
});

export const ClaimAllStatusRewardsResponseSchema = z.object({
  rewards: z.array(ClaimRewardSchema),
});
